module.exports = __webpack_public_path__ + "assets/img/app-dec3.f2b18b4f.svg";